import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import strings from 'localization/strings';

import Alert from '@material-ui/lab/Alert';
import MarginBox from 'common/MarginBox';

const ActorBlocker = ({ block = false, children }) => {
    const authenticationContext = useSelector(state => state.authentication.context);

    if(!block) {
        return children;
    }

    if(authenticationContext.isSuperAdminOrImpersonated) {
        return (
            <>
                <MarginBox top={4} bottom={4}>
                    <Alert severity="warning">
                        {strings.userBlockedMessageForSuperAdmin}
                    </Alert>
                </MarginBox>
                {children}
            </>
        );
    }

    return (
        <MarginBox top={4} bottom={4}>
            <Alert severity="error">
                {strings.userBlockedMessage}
            </Alert>
        </MarginBox>
    );
};

ActorBlocker.propTypes = {
    block: PropTypes.bool,
    children: PropTypes.node
};

export default ActorBlocker;
